import _ajax from './ajax';
import _setUserAuthDataToLocalStorage from '../toolbox/setUserAuthDataToLocalStorage';
import _handleAjax401Error from './handleAjax401Error';
import _removeUserAuthDataFromLocalStorage from './removeUserAuthDataFromLocalStorage';
import _getUserAuthDataFromLocalStorage from './getUserAuthDataFromLocalStorage';
import _urlWrapper from './urlWrapper';
import _apiWrapper from './apiWrapper';
import _authWrapper from './authWrapper';
import _publicUrlWrapper from './publicUrlWrapper';
import _getUserDataStringFromMetadata from './getUserDataStringFromMetadata';
import _setUserLanguageToLocalStorage from '../toolbox/setUserLanguageToLocalStorage';
import _getUserLanguageFromLocalStorage from './getUserLanguageFromLocalStorage';

export const ajax = _ajax;
export const getUserAuthDataFromLocalStorage = _getUserAuthDataFromLocalStorage;
export const handleAjax401Error = _handleAjax401Error;
export const removeUserAuthDataFromLocalStorage = _removeUserAuthDataFromLocalStorage;
export const setUserAuthDataToLocalStorage = _setUserAuthDataToLocalStorage;
export const urlWrapper = _urlWrapper;
export const apiWrapper = _apiWrapper;
export const authWrapper = _authWrapper;
export const publicUrlWrapper = _publicUrlWrapper;
export const getUserDataStringFromMetadata = _getUserDataStringFromMetadata;
export const setUserLanguageToLocalStorage = _setUserLanguageToLocalStorage;
export const getUserLanguageFromLocalStorage = _getUserLanguageFromLocalStorage;



// WEBPACK FOOTER //
// ./src/utils/index.js